import { orpc } from "@/utils/orpc.client";

export function getNotificationPreviewQueryOptions() {
  return orpc.notifications.getNotifications.queryOptions({ input: { limit: 8 } });
}
